// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/cnquery_cnspec_actions.go

export const SYNCHRONIZE_ASSETS =
  "cnquery.explorer.QueryConductor.SynchronizeAssets";
